"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _awsAmplify = _interopRequireWildcard(require("aws-amplify"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _LoaderButton = _interopRequireDefault(require("../LoaderButton"));

var _hooksLib = require("../../libs/hooksLib");

require("./SignUp.scss");

var _index = _interopRequireDefault(require("../Modal/index"));

var _index2 = _interopRequireDefault(require("../Button/index"));

var _formatHelper = require("../../libs/formatHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SignUp = function SignUp(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMsg = _useState4[0],
      setErrorMsg = _useState4[1];

  var className = 'SignUp';
  if (props.containerClasses) className += " ".concat(props.containerClasses);

  _awsAmplify["default"].configure({
    Auth: {
      mandatorySignIn: true,
      region: props.REGION,
      userPoolId: props.USER_POOL_ID,
      identityPoolId: props.IDENTITY_POOL_ID,
      userPoolWebClientId: props.APP_CLIENT_ID,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      oauth: {
        domain: props.COGNITO_DOMAIN,
        scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: props.COGNITO_SIGNIN_CALLBACK,
        redirectSignOut: props.COGNITO_SIGNOUT_CALLBACK,
        responseType: props.responseType || 'code'
      }
    }
  });

  var _useFormFields = (0, _hooksLib.useFormFields)({
    email: props.email || '',
    password: '',
    confirmPassword: '',
    given_name: '',
    family_name: '',
    phone_number: '',
    confirmationCode: ''
  }),
      _useFormFields2 = _slicedToArray(_useFormFields, 2),
      fields = _useFormFields2[0],
      handleFieldChange = _useFormFields2[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      newUser = _useState6[0],
      setNewUser = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  function validateForm() {
    return fields.email.length > 0 && fields.password.length > 0 && fields.password === fields.confirmPassword;
  }

  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }

  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
      var email, password, family_name, given_name, phone_number, _newUser, accessToken;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault(); // some way for user to pass down "blocked" domains, so lets say
              // we only want @syngenta.com emails to go through SSO and not this way
              // then here we can do logic on email to see if the email is a valid non-sso email

              email = fields.email, password = fields.password, family_name = fields.family_name, given_name = fields.given_name, phone_number = fields.phone_number;
              setIsLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return _awsAmplify.Auth.signUp({
                username: email,
                password: password,
                attributes: {
                  family_name: family_name,
                  given_name: given_name,
                  phone_number: phone_number
                }
              });

            case 6:
              _newUser = _context.sent;
              _newUser = _newUser.user ? _newUser.user : _newUser;
              accessToken = _newUser.pool.storage.accessToken ? _newUser.pool.storage.accessToken : ["".concat(_newUser.keyPrefix, ".").concat(email, ".accessToken")];
              window.sessionStorage.setItem('accessToken', accessToken);
              setIsLoading(false);
              setNewUser(_newUser);
              props.handler && props.handler({
                user: _newUser,
                error: null
              });
              _context.next = 21;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](3);
              setErrorMsg(_context.t0.message);
              setShowModal(true);
              setIsLoading(false);
              props.handler && props.handler({
                error: _context.t0.message,
                user: null
              });

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 15]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }

  function handleSSO(event, provider) {
    event.preventDefault();

    _awsAmplify.Auth.federatedSignIn({
      provider: provider
    });
  }

  function renderForm() {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
      controlId: "email",
      bsSize: "large"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, "Email"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
      type: "email",
      value: fields.email,
      onChange: handleFieldChange,
      onKeyDown: function onKeyDown(e) {
        return (0, _formatHelper.preventWhiteSpace)(e);
      }
    })), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
      controlId: "password",
      bsSize: "large"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, "Password"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
      type: "password",
      value: fields.password,
      onChange: handleFieldChange
    })), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
      controlId: "confirmPassword",
      bsSize: "large"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, "Confirm Password"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
      type: "password",
      onChange: handleFieldChange,
      value: fields.confirmPassword
    })), /*#__PURE__*/_react["default"].createElement(_LoaderButton["default"], {
      isLoading: isLoading,
      disabled: !validateForm()
    }, "Signup"), (props.googleLogin || props.facebookLogin || props.SSOLogin) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "w100%"
    }, props.googleLogin && /*#__PURE__*/_react["default"].createElement(_LoaderButton["default"], {
      customClassName: "custom-button google-red mt15",
      clickHandler: function clickHandler(e) {
        return handleSSO(e, 'Google');
      }
    }, "Signup with\xA0", /*#__PURE__*/_react["default"].createElement("i", {
      className: "fa fa-google",
      "aria-hidden": "true"
    })), props.facebookLogin && /*#__PURE__*/_react["default"].createElement("div", {
      className: "w100%"
    }, /*#__PURE__*/_react["default"].createElement(_LoaderButton["default"], {
      customClassName: "custom-button facebook-blue mt15",
      clickHandler: function clickHandler(e) {
        return handleSSO(e, 'Facebook');
      }
    }, "Signup with\xA0", /*#__PURE__*/_react["default"].createElement("i", {
      className: "fa fa-facebook",
      "aria-hidden": "true"
    }))), props.SSOLogin && /*#__PURE__*/_react["default"].createElement("div", {
      className: "w100%"
    }, /*#__PURE__*/_react["default"].createElement(_LoaderButton["default"], {
      customClassName: "custom-button bgc-black c-white mt15",
      clickHandler: function clickHandler(e) {
        return handleSSO(e, 'SyngentaSSO');
      }
    }, "Continue with SSO\xA0", /*#__PURE__*/_react["default"].createElement("i", {
      className: "fa fa-key",
      "aria-hidden": "true"
    }))))));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
    customClassName: "p25",
    handleClose: function handleClose() {
      setShowModal(false);
    },
    show: showModal
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, errorMsg), /*#__PURE__*/_react["default"].createElement(_index2["default"], {
    type: "success",
    customClassName: "mt20",
    clickHandler: function clickHandler() {
      return setShowModal(false);
    },
    text: "Close"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb75"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: props.logoPath,
    alt: "company logo"
  })), renderForm());
};

SignUp.propTypes = {
  REGION: _propTypes["default"].string.isRequired,
  USER_POOL_ID: _propTypes["default"].string.isRequired,
  IDENTITY_POOL_ID: _propTypes["default"].string.isRequired,
  APP_CLIENT_ID: _propTypes["default"].string.isRequired
};
var _default = SignUp;
exports["default"] = _default;